import React, { ReactNode } from 'react';
import { Button, Text } from '@thinkific/chalk/react-components';
import { CaretLeft } from '@thinkific/chalk/react-icons';
import { NotificationPane } from 'components/NotificationPane';
import UserAvatar from 'components/UserAvatar';
import { useCommunityContext } from 'components/CommunityContext';
import * as css from './ContextHeader.css';

interface ContextHeaderProps {
  pageTitle: string;
  breadcrumb?: {
    url: string;
    onClick: (
      e: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
    ) => void;
  };
  action?: ReactNode;
}

export const ContextHeader = ({
  pageTitle,
  breadcrumb,
  action,
}: ContextHeaderProps) => {
  const { currentUser } = useCommunityContext();

  return (
    <nav className={css.container} data-qa="top-bar">
      <div className={css.leftContainer}>
        {breadcrumb ? (
          <>
            <Button
              aria-label="Go back"
              emphasis="lowCompact"
              href={breadcrumb.url}
              icon={CaretLeft}
              iconPosition="lead"
              hiddenLabel
              onClick={breadcrumb.onClick}
            >
              {pageTitle}
            </Button>
            <Text variant="display.base">{pageTitle}</Text>
          </>
        ) : (
          <Text variant="display.base">{pageTitle}</Text>
        )}
      </div>

      <div className={css.rightContainer}>
        {action}
        <NotificationPane />
        <UserAvatar
          size="xs"
          {...currentUser}
          userId={currentUser.id}
          username={currentUser.fullName}
          shouldOpenSideMenu
        />
      </div>
    </nav>
  );
};

export default ContextHeader;
